import { mapValues } from 'lodash';

/**
 * A simple identity function to grab the form from the slice of state.
 */
const getForm = (state) => state;

/**
 * Gets the form's inputs.
 */
const getInputs = (state) => getForm(state).inputs;

/**
 * Gets the specified input from the form.
 */
const getInput = (state, inputId) => getInputs(state)[inputId];

const selectors = {
  getForm, getInputs, getInput
};

/**
 * A convenience function that allows an application to create selectors
 * that are aware of where the form lives in the entire state tree.
 */
export const createScopedFormSelectors = (getFormInState) => {
  const promoteSelector = selector => (state, ...args) => selector(getFormInState(state), ...args);
  return { ...mapValues(selectors, promoteSelector) };
};

export default selectors;
